import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { ChangeHistoryService } from '../change-history.service';

@Component({
    selector: 'app-change-history-list',
    templateUrl: './change-history-list.component.html',
    styleUrls: ['./change-history-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class ChangeHistoryListComponent implements OnInit {

	@Input() localId: any;
	@Input() typeName: any;

	constructor(
		private alertService: AlertService,
		private changeHistoryService: ChangeHistoryService,
	) {
		
	}

	columns = [
		{ field: 'commitId', header: 'Commit Id', width: 'auto' },
		{ field: 'author', header: 'Author', width: 'auto' },
		{ field: 'commitDate', header: 'Date', width: 'auto' },
		{ field: 'commitDateInstant', header: 'DateInstant', width: 'auto' },
		{ field: 'version', header: 'Version', width: 'auto' },
		{ field: 'type', header: 'Type' },
		{ field: 'changedProperties', header: 'Changed Properties' },
		{ field: 'state', header: 'State' },
		{ field: 'localId', header: 'Local Id' },
		{ field: 'typeName', header: 'Type Name' },
	  ];

	changeHistoryList: any;
	loading : boolean = false;

	ngOnInit(): void {
		try {
			let requestApi = {
				localId : this.localId,
				typeName: this.typeName
			};
			this.getChangeHistoryList(requestApi);
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	getChangeHistoryList(requestApi: any) {
		try {
			this.loading = true;
			this.changeHistoryService.getChangeHistoryList(requestApi)
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.changeHistoryList = res.data.javersSnapshotAPIS;
						this.loading = false;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
						this.loading = false;
					},
					() => { 
						this.loading = false;
					});
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

}
